<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    width: '20',
    height: '21',
    viewBox: '0 0 20 21',
    color: '#A3A3A3',
  }
);
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Union"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0298 9.50019L10.6879 2.20905C10.5246 2.0213 10.4329 1.76665 10.4329 1.50114C10.4329 1.23562 10.5246 0.980973 10.6879 0.793225C10.8511 0.605476 11.0726 0.499999 11.3035 0.499999C11.5344 0.499999 11.7558 0.605476 11.9191 0.793226L19.7446 9.79209C19.8255 9.88497 19.8898 9.99531 19.9336 10.1168C19.9774 10.2383 20 10.3685 20 10.5C20 10.6315 19.9774 10.7617 19.9336 10.8832C19.8898 11.0047 19.8255 11.115 19.7446 11.2079L11.9191 20.2068C11.7558 20.3945 11.5344 20.5 11.3035 20.5C11.0726 20.5 10.8511 20.3945 10.6879 20.2068C10.5246 20.019 10.4329 19.7644 10.4329 19.4989C10.4329 19.2333 10.5246 18.9787 10.6879 18.791L17.0297 11.4999L0.869468 11.4999C0.638863 11.4999 0.417703 11.3946 0.254639 11.2071C0.0915784 11.0196 -2.96665e-05 10.7652 -2.96434e-05 10.5001C-2.96202e-05 10.2349 0.0915784 9.98055 0.25464 9.79304C0.417703 9.60553 0.638864 9.50019 0.869468 9.50019L17.0298 9.50019Z"
      :fill="props.color"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
